import { Timestamp } from '@angular/fire/firestore';

export type OrganizationRequestType = 'charity' | 'business' | 'religious' | 'other';
export type OrganizationRequestStatus = 'pending' | 'approved' | 'rejected';

export const ORGANIZATION_REQUEST_TYPES: { value: OrganizationRequestType; label: string }[] = [
  { value: 'charity', label: 'Registered charity / non-profit' },
  { value: 'religious', label: 'Registered religious body' },
  { value: 'business', label: 'Licensed business' },
  { value: 'other', label: 'Other registered organization' },
];

export interface OrganizationRequestDocument {
  name: string;
  storagePath: string;
  contentType: string;
  size: number;
}

/** A request to create an organization, reviewed by a platform admin (organization_requests) */
export interface OrganizationRequest {
  id: string;
  requesterId: string;
  requesterName: string;
  requesterEmail: string;
  name: string;
  purpose: string;
  orgType: OrganizationRequestType;
  registrationNumber: string;
  country: string;
  contactEmail: string;
  contactPhone?: string;
  documents: OrganizationRequestDocument[];
  status: OrganizationRequestStatus;
  reviewNote?: string;
  reviewedBy?: string;
  reviewedAt?: Timestamp;
  organizationId?: string;
  created?: Timestamp;
  modified?: Timestamp;
}

export interface OrganizationRequestInput {
  requestId: string;
  name: string;
  purpose: string;
  orgType: OrganizationRequestType;
  registrationNumber: string;
  country: string;
  contactEmail: string;
  contactPhone?: string;
}
